module.exports = __webpack_public_path__ + "media/6_Long.a5bbd659.mp3";